<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__dict">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <!-- <el-form-item>
          <el-input
            v-model="dataForm.dictName"
            :placeholder="$t('dict.dictName')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.dictType"
            :placeholder="$t('dict.dictType')"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button
            @click="getDataList()"
            type="primary"
            v-permission="['/System/Dictionary/Search']"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-permission="['/System/Dictionary/Add']"
            type="primary"
            @click="addOrUpdateHandle()"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="KeyName"
          label="名称"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="KeyType"
          label="类型"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="childHandle(scope.row)">{{
              scope.row.KeyType
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="Sort"
          label="排序"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="Remark"
          label="备注"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          header-align="center"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-permission="['/System/Dictionary/Edit']"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-permission="['/System/Dictionary/Delete']"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.Id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
        style="margin-top: 20px"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./dict-type-add-or-update";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        deleteMethod: 'post',
        getDataListURL: "/api/Dictionary/PostAllDictionaryKeyList",
        getDataListIsPage: true,
        deleteURL: "/api/Dictionary/DeleteDictionaryKey",
      },
      dataForm: {},
    };
  },
  components: {
    AddOrUpdate,
  },
  methods: {
    // 子级
    childHandle(row) {
      this.$router.push({
        path: "/System/DictionaryValue",
        query: { KeyType: row.KeyType, Id: row.Id },
      });
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.Id = row ? row.Id : '';
        this.$refs.addOrUpdate.dataForm.KeyName = row ? row.KeyName : '';
        this.$refs.addOrUpdate.dataForm.KeyType = row ? row.KeyType : '';
        this.$refs.addOrUpdate.dataForm.Sort = row ? row.Sort : 0;
        this.$refs.addOrUpdate.dataForm.Remark = row ? row.Remark : '';
        this.$refs.addOrUpdate.init();
      });
    },
  },
};
</script>
